import Vue from 'vue'
import {
  Toast,
  Lazyload,
  List,
  Image,
  Picker,
  Field,
  Icon,
  PullRefresh,
  Popup,
  Empty,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Dialog,
  DropdownMenu,
  DropdownItem,
  SwipeCell,
  Cell,
  Button,
  DatetimePicker,
  Stepper,
  Step,
  Steps,
  Tabs,
  Tab,
  Search,
  Switch,
  Tag,
  CountDown,
  ImagePreview,
  Grid,
  GridItem,
  NavBar,
  Swipe,
  SwipeItem,
  CellGroup,
  Form,
  ActionSheet
} from 'vant'

Vue.use(Toast)
.use(Lazyload)
.use(List)
.use(Image)
.use(Picker)
.use(Field)
.use(Icon)
.use(PullRefresh)
.use(Popup)
.use(Empty)
.use(Checkbox)
.use(CheckboxGroup)
.use(Radio)
.use(RadioGroup)
.use(Dialog)
.use(DropdownMenu)
.use(DropdownItem)
.use(SwipeCell)
.use(Cell)
.use(Button)
.use(DatetimePicker)
.use(Stepper)
.use(Step)
.use(Steps)
.use(Tabs)
.use(Tab)
.use(Search)
.use(Switch)
.use(Tag)
.use(CountDown)
.use(ImagePreview)
.use(Grid)
.use(GridItem)
.use(NavBar)
.use(Swipe)
.use(SwipeItem)
.use(CellGroup)
.use(Form)
.use(ActionSheet)
Toast.setDefaultOptions({
    duration: 1500
})
